import { EventTypes } from '@dicetechnology/doris-core';
import type { Player } from '@dicetechnology/doris-core';
import { isAsyncHlsHandlerDefinition } from '@dicetechnology/doris-handler-hls';
import { isAsyncShakaHandlerDefinition } from '@dicetechnology/doris-handler-shaka';

import { DiceReceiverManager, DiceReceiverManagerEvents } from '../services';

export const configureHandlerPreloading = (player: Player) => {
    if (typeof window.requestIdleCallback !== 'function') {
        return;
    }

    const logger = player.getServices().log.createLogger('configureHandlerPreloading');

    const diceReceiverManager = DiceReceiverManager.getInstance();

    let loadRequestReceived = false;

    player.once(EventTypes.LOAD_REQUEST, () => {
        loadRequestReceived = true;
    });

    let handle: number | undefined;

    const prefetchHandlers = () => {
        diceReceiverManager.removeListener(DiceReceiverManagerEvents.CONFIGURED, prefetchHandlers);
        if (loadRequestReceived) {
            logger.log('Handler prefetching has been interrupted by call to player.load()');
            return;
        }
        handle = window.requestIdleCallback(() => {
            if (loadRequestReceived) {
                logger.log('Handler prefetching has been interrupted by call to player.load()');
                return;
            }
            logger.log('Prefetching handlers...');
            const config = player.getConfig();
            config.handlers
                .find(isAsyncHlsHandlerDefinition)
                ?.loadHandler()
                .then(() => logger.log('HlsHandler prefetched'))
                .catch(() => logger.warn('Failed to prefetch HlsHandler'));
            config.handlers
                .find(isAsyncShakaHandlerDefinition)
                ?.loadHandler()
                .then(() => logger.log('ShakaHandler prefetched'))
                .catch(() => logger.warn('Failed to prefetch ShakaHandler'));
        });
    };

    if (diceReceiverManager.getSettings()) {
        prefetchHandlers();
    } else {
        diceReceiverManager.addListener(DiceReceiverManagerEvents.CONFIGURED, prefetchHandlers);
    }
};
